import { Component } from '@angular/core';
import {ThemeOptions} from '../../theme-options';
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../service/user.service";
import {BsModalService} from "ngx-bootstrap";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
    sys: string;

  constructor(public globals: ThemeOptions,private formBuilder: FormBuilder, private route: Router, private notifierService: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.sys=localStorage.getItem('system')
  }

  toggleSidebarMobileOpen() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
    this.globals.toggleSidebar = false;
  }

  getbussinus(){

  }

}
